












import {ChartDataTemplate, FCConfTpl, WConfTpl, WidgetDefinition, WParamTpl} from "@/components/widgets/WidgetFather"
import {defineComponent, reactive, ref, watch} from "@vue/composition-api"
import {executeQuery} from "@/data/repos/query"
import {bus} from "@/main"
import {getAppraisalCaption, getLocationCaption} from "@/data/sources/appraisal"
import {extractAppraisalItem, getAppraisalLastElementName} from "@/data/repos/appraisal"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"

export function config(): WidgetDefinition {
  return {
    ...WConfTpl.KeyValue(),
    widget: "AppraisalFacetScores",
    title: "Appraisal facet scores",
    _description: "The facet score chart allows users to view the summary of Score values for a facet. Scores are facet based in the appraisal hierarchy.",
    params: {
      locationId: {...WParamTpl.locationId(), _order: 1},
      appraisalEntity: {...WParamTpl.Appraisal(), _order: 2},
    },
  }
}

function getChartConfig() {
  return reactive(FCConfTpl())
}

function getChartDataConfig() {
  return reactive({
      ...ChartDataTemplate(),
      showValues: "1",
      enableSmartLabels: "1",
      showLegend: "1",
    },
  )
}

export default defineComponent({
  props: {
    config: Object,
  },
  components: {
    FusionChartWidget,
  },
  setup(props, context) {
    const errorMessage = ref("")
    context.emit("config-update", config())

    async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
      if (config) {
        chartDataConfig.subCaption =
            "Location: " + await getLocationCaption(config.params.locationId) + "<br>" +
            "Appraisal: " + getAppraisalCaption(config.params.appraisalEntity)
      }
    }

    function dataplotClickCallback(label: string, val: any) {
      const params = props.config && props.config.params
      showDrillDown(label, val, params)
    }

    async function dataFetcher(params: any): Promise<{ data: any[] | null }> {
      const item = extractAppraisalItem(params.appraisalEntity)
      if (!item || !item.facetId) {
        errorMessage.value = "Please configure Facet"
        return {data: []}
      }
      errorMessage.value = ""
      const elementName = getAppraisalLastElementName(item)
      if (elementName) {
        return {
          data: await executeQuery(
            "idr", "appraisal.score.score_" + elementName, {
              locationId: parseInt(params.locationId.value),
              surveyId: item.surveyId,
              facetId: item.facetId,
              categoryId: item.categoryId,
              elementId: item.elementId,
              subelementId: item.subelementId,
            },
            convert),
        }
      } else {
        return {data: []}
      }

      function convert(data: any[]): any[] {
        return data.map(item => {
          return {
            label: `${item.conditionRating}: ${item.description}`,
            value: item.CountOfRank,
            color:
              item.conditionRating == "DX" ? "#ff06a8" :
                item.conditionRating == "D" ? "#ff0112" :
                  item.conditionRating == "CX" ? "#ff6209" :
                    item.conditionRating == "C" ? "#ff9a0d" :
                      item.conditionRating == "B(C)" ? "#fffb11" :
                        item.conditionRating == "B" ? "#04f002" :
                          item.conditionRating == "A" ? "#4d7fff" :
                            null,
          }
        })
      }
    }

    return {dataFetcher, getChartDataConfig, dataplotClickCallback, configChangeCallback, errorMessage}
  },
})

function showDrillDown(label: string, val: any, params: any) {
  bus.$emit("modalBoxCreate", {
    component: () => import("@/components/widgets/appraisal/AppraisalFacetScoresDrillDown.vue"),
    componentArgs: {
      locationId: params.locationId.value,
      risk: extractAppraisalItem(params.appraisalEntity),
      year: parseInt(label),
    },
  })
}
